import { createContext, useContext } from 'react';

/**
 * What every admin page can read from the shell: the layout mode (the shell measures
 * its own width), the rail counts, and the shared AREA (city + radius).
 */
export const AdminShellContext = createContext({
  mode: 'desktop',
  isMobile: false,
  isTablet: false,
  counts: null,
  refreshCounts: () => {},
  area: null,
  setTakeover: () => {},
  /** A black pill at the bottom centre for 2.6s — every panel write says so this way. */
  toast: () => {},
  /** Open the person drawer (`?person=<userId>`). One drawer, mounted by the shell. */
  openPerson: () => {},
  closePerson: () => {},
  /** Whether this person may read a person's record at all — the drawer's gate. */
  canSeePeople: false,
});

export const useAdminShell = () => useContext(AdminShellContext);
